import { infoCenterLocales, APP_LOCALES } from 'locale/locale.config';

import { AppStore } from 'stores/AppStore';

import InstagramIcon from 'components/shared/icons/InstagramIcon';
import FacebookIcon from 'components/shared/icons/FacebookIcon';
import YouTubeIcon from 'components/shared/icons/YouTubeIcon';

const socialLinks = {
  instagram: {
    icon: InstagramIcon,
    newTab: true,
    label: 'Instagram',
    url: process.env.INSTAGRAM_PAGE_URL,
  },
  facebook: {
    icon: FacebookIcon,
    newTab: true,
    label: 'Facebook',
    url: process.env.FACEBOOK_PAGE_URL,
  },
  youTube: {
    icon: YouTubeIcon,
    newTab: true,
    label: 'YouTube',
    url: process.env.YOUTUBE_PAGE_URL,
  },
};

const links = {
  contactUs: {
    label: 'Contact us',
    url: '/contact-us',
  },
  cookieNotice: {
    label: 'Cookie notice',
    url: '/cookie-notice',
  },
  deliveryOptions: {
    label: 'Delivery options',
    url: '/delivery-options',
  },
  faq: {
    label: 'FAQs',
    url: '/faqs',
  },
  infoCenter: {
    label: 'Info Centre',
    url: '/info-center',
  },
  privacyPolicy: {
    label: 'Privacy policy',
    url: '/privacy-policy',
  },
  termsAndConditions: {
    label: 'Terms and conditions',
    url: '/terms-and-conditions',
  },
};

// Social links that are unique by brand
const socialLinksByBrand = {
  [process.env.BRANDS.velieve.id]: [
    socialLinks.instagram,
    socialLinks.facebook,
    socialLinks.youTube,
  ],
  [process.env.BRANDS.diputi.id]: [socialLinks.facebook],
};

export function getFooterLinks(localeCode) {
  const showInfoCenter = infoCenterLocales.includes(localeCode);

  const isUkVelieve = localeCode === APP_LOCALES.UK && !AppStore.isDipUti;

  const ukLinks = [
    {
      label: process.env.BRAND_NAME,
      links: [links.contactUs],
    },
    {
      label: 'Legal',
      links: [
        links.cookieNotice,
        links.privacyPolicy,
        links.termsAndConditions,
      ],
    },
  ];

  const nonUkLinks = [
    {
      label: process.env.BRAND_NAME,
      links: [
        ...(showInfoCenter ? [links.infoCenter] : []),
        links.faq,
        links.contactUs,
      ],
    },
    {
      label: 'Legal',
      links: [
        links.cookieNotice,
        links.privacyPolicy,
        links.termsAndConditions,
      ],
    },
    {
      label: 'Follow us',
      links: socialLinksByBrand[process.env.DEPLOY_BRAND],
    },
  ];

  return isUkVelieve ? ukLinks : nonUkLinks;
}
